import styled from "@emotion/styled";
import { useQueryClient } from "@tanstack/react-query";
import { Button, Form, Input, message, Modal, Select, Spin } from "antd";
import React, { useEffect, useState } from "react";


import { GetMasterPoint } from "services/interface";
import SettingPointFormEdit from "./SettingPointFormEdit";
import { useUpdateMasterPoint } from "hooks/useMasterData";
import { useAppSelector } from "store";

const { Option } = Select;

interface ModalAddUserProps {
  editData: GetMasterPoint | undefined;
  isShow: boolean;
  onClose: () => void;
}

const ModalEditUser = ({ editData, isShow, onClose }: ModalAddUserProps) => {
  const queryClient = useQueryClient();

  const { mutate, isPending } = useUpdateMasterPoint();

  const [showModal, setShowModal] = useState<boolean>(false);

  const [formModal] = Form.useForm();

  const contact = useAppSelector((state) => state.auth.contact);

  useEffect(() => {
    if (editData) {
      formModal.setFieldsValue({
        money_amt: editData?.money_amt,
        point_amt: editData?.point_amt,
        is_active: editData?.is_active,
      });
    }
  }, [editData, formModal]);

  const onCloseModal = () => {
    setShowModal(false);
    onClose();
  };

  const onFinishModal = (values: any) => {
    mutate(
      {
        id: editData?.id || "",
        money_amount: parseInt(values?.money_amt || "0"),
        point_amount: parseInt(values?.point_amt || "0"),
        factory_id: contact?.id || "",
        is_active: values?.is_active || false,
      },
      {
        onSuccess: async (data) => {
          if (!data.error_message) {
            await queryClient.refetchQueries({
              queryKey: ["get_master_point"],
              type: "active",
            });
            onCloseModal();
            message.success("แก้ไขการเติม Point สำเร็จ");
            formModal.resetFields();
          } else {
            message.error(`แก้ไขการเติม Point ไม่สำเร็จ: ${data.error_message}`);
            formModal.resetFields();
          }
        },
      }
    );
  };

  return (
    <div>
      <Modal
        title="แก้ไขการเติม Point"
        open={isShow}
        maskClosable={false}
        onCancel={() => {
          onClose();
        }}
        width={600}
        style={{ top: 20 }}
        footer={null}
      >
        <WrapperAll>
          <SettingPointFormEdit
            form={formModal}
            onFinish={onFinishModal}
            isPending={isPending}
            editData={editData}
          />
        </WrapperAll>
      </Modal>
    </div>
  );
};

export default ModalEditUser;

const WrapperAll = styled.div`
  display: block;
  width: 100%;
  overflow-y: auto;
  overflow-x: hidden;
  padding: 10px;
`;
